import BaseComponent from '../../../base/base_component';
import DOM from '../../../utils/dom';
import {USER_EVENTS} from '../../../events/events';
import * as NavbarConst from '../navbar_const';

let gameModeTogglesHtml = require('../view/gamemode-toggles.html');

export default class GameModeToggleNavbarPart extends BaseComponent {
    static CLASS = 'GameModeToggleNavbarPart';

    init(params) {
        super.init(params);
        this._isReal = params.isReal;
        this._isFreePlay = params.isFreePlay;
        this._switchGameModeCallback = params.switchGameModeCallback;
        this._analyticsTrigger = params.analyticsTrigger;

        DOM.html(this.bake(gameModeTogglesHtml), this.getEl());
        DOM.addClass(this.getEl(), 'cgp-navbar-toggle-wrapper');
        this._setCheckboxElementValue();
        this._setStyles();
        this._subscribe();

    }


    _subscribe() {
        this._subscribeToggleAction(NavbarConst.ELEMENTS.CHECKBOX, USER_EVENTS.ON_CHANGE, null);
        this._subscribeToggleAction(NavbarConst.ELEMENTS.REAL, USER_EVENTS.ON_CLICK, true);
        this._subscribeToggleAction(NavbarConst.ELEMENTS.ANONYMOUS, USER_EVENTS.ON_CLICK, false);
    }


    _getCheckboxElement() {
        let checkbox = this.querySelector(NavbarConst.ELEMENTS.CHECKBOX);
        if (!checkbox) {
            this.throwError('37', `Missing ${NavbarConst.ELEMENTS.CHECKBOX} CSS class from the gamemode-toggles.html`);
        }

        return checkbox;
    }

    _setCheckboxElementValue() {
        this._getCheckboxElement().checked = this._isReal;
    }

    _subscribeToggleAction(elementSelector, eventName, state) {
        this.onChildElementEvent(elementSelector, eventName, (event) => {
            event.preventDefault();

            let checkbox = this._getCheckboxElement();

            if (checkbox.checked === state) {
                return;
            }

            checkbox.checked = !checkbox.checked;

            this._analyticsTrigger.send(checkbox.checked ? NavbarConst.ANALYTICS.ACTION.REAL : NavbarConst.ANALYTICS.ACTION.ANONYMOUS);

            this._setStyles();

            this._switchGameModeCallback()
                .then(() => this._setStyles())
                .catch(() => {
                    this._setCheckboxElementValue();
                    this._setStyles();
                });
        });
    }

    _setStyles() {
        let checkbox = this._getCheckboxElement();

        let navbarToggle = this.querySelector(NavbarConst.ELEMENTS.TOGGLES);
        let toggleCircle = this.querySelector(NavbarConst.ELEMENTS.TOGGLE_CIRCLE);
        let realTextElem = this.querySelector(NavbarConst.ELEMENTS.TOGGLE_REAL_TEXT);
        let demoTextElem = this.querySelector(NavbarConst.ELEMENTS.TOGGLE_ANNONYMOUS_TEXT);
        let navbarCheckbox = this.querySelector(NavbarConst.ELEMENTS.CHECKBOX_LABEL);

        let toggleLeftBgElem = this.querySelector(NavbarConst.ELEMENTS.GAME_FRAME_BG_LEFT);
        let toggleRightBgElem = this.querySelector(NavbarConst.ELEMENTS.GAME_FRAME_BG_RIGHT);

        this._cleanStyle(navbarToggle, toggleCircle, realTextElem, demoTextElem, navbarCheckbox, toggleLeftBgElem, toggleRightBgElem);

        if (this._isFreePlay) {
            // Add classes for the option not to use toggle box.
            DOM.addClass(navbarToggle, 'cgp-themes-gameframe-bg-no-toggle');
            DOM.addClass(navbarToggle, 'cgp-themes-gameframe-bg-fp');
            DOM.addClass(navbarToggle, 'cgp-theme-property-background-color-secondary');

            let titleTextElem = DOM.createElement('span', this._getFreePlayTitleById(this._model.getFreePlayTypeID()));
            let toggleEl = this.getEl().querySelector(NavbarConst.ELEMENTS.TOGGLES);
            DOM.removeElement(toggleEl, toggleEl.querySelector('.cgp-fp-game-toggle'));
            DOM.addClass(titleTextElem, 'cgp-fp-game-toggle');
            DOM.addClass(titleTextElem, 'cgp-themes-main-title2');
            DOM.addClass(titleTextElem, 'cgp-theme-property-color-dark-main');
            DOM.addClass(titleTextElem, 'cgp-navbar-toggle-title');
            DOM.addClass(toggleLeftBgElem, 'cgp-themes-icons-gameframe-bg-fp-left');
            DOM.addClass(toggleRightBgElem, 'cgp-themes-icons-gameframe-bg-fp-right');
            DOM.append(this.getEl().querySelector(NavbarConst.ELEMENTS.TOGGLES), titleTextElem);
        } else if (checkbox.checked) {
            // Add classes for the toggle box.
            DOM.addClass(navbarToggle, 'cgp-theme-property-background-color-base05');
            DOM.addClass(toggleLeftBgElem, 'cgp-themes-icons-gameframe-bg-real-left');
            DOM.addClass(toggleRightBgElem, 'cgp-themes-icons-gameframe-bg-real-right');

            // Add classes for the toggle.
            DOM.addClass(navbarCheckbox, 'cgp-theme-property-background-color-main');

            // Add classes for the toggle circle.
            DOM.addClass(toggleCircle, 'cgp-theme-property-background-color-base01');

            // Change toggle texts style.
            DOM.addClass(demoTextElem, 'cgp-themes-secondary-text');
            DOM.addClass(realTextElem, 'cgp-themes-main-title');

        } else {
            // Add classes for the toggle box.
            DOM.addClass(navbarToggle, 'cgp-theme-property-background-color-base01');
            DOM.addClass(toggleLeftBgElem, 'cgp-themes-icons-gameframe-bg-demo-left');
            DOM.addClass(toggleRightBgElem, 'cgp-themes-icons-gameframe-bg-demo-right');

            // Add classes for the toggle.
            DOM.addClass(navbarCheckbox, 'cgp-theme-property-background-color-darkmain');

            // Add classes for the toggle circle.
            DOM.addClass(toggleCircle, 'cgp-theme-property-background-color-base01');

            // Change toggle texts style.
            DOM.addClass(demoTextElem, 'cgp-themes-main-title');
            DOM.addClass(demoTextElem, 'cgp-theme-property-color-dark-main');
            DOM.addClass(realTextElem, 'cgp-themes-secondary-text');
            DOM.addClass(realTextElem, 'cgp-theme-property-color-dark-main');
        }
    }


    _cleanStyle(navbarToggle, toggleCircle, realTextElem, demoTextElem, navbarCheckbox, toggleLeftBgElem, toggleRightBgElem) {
        DOM.removeClass(navbarToggle, 'cgp-themes-gameframe-bg-no-toggle');
        DOM.removeClass(navbarToggle, 'cgp-themes-gameframe-bg-fp');
        DOM.removeClass(navbarToggle, 'cgp-theme-property-background-color-secondary');
        DOM.removeClass(navbarToggle, 'cgp-theme-property-background-color-base05');
        DOM.removeClass(navbarToggle, 'cgp-theme-property-background-color-base01');

        DOM.removeClass(toggleCircle, 'cgp-theme-property-background-color-base01');

        DOM.removeClass(realTextElem, 'cgp-themes-main-text');
        DOM.removeClass(realTextElem, 'cgp-themes-secondary-text');
        DOM.removeClass(realTextElem, 'cgp-theme-property-color-dark-main');

        DOM.removeClass(demoTextElem, 'cgp-themes-secondary-text');
        DOM.removeClass(demoTextElem, 'cgp-themes-main-title');
        DOM.removeClass(demoTextElem, 'cgp-theme-property-color-dark-main');

        DOM.removeClass(navbarCheckbox, 'cgp-theme-property-background-color-main');
        DOM.removeClass(navbarCheckbox, 'cgp-theme-property-background-color-darkmain');

        DOM.removeClass(toggleLeftBgElem, 'cgp-themes-icons-gameframe-bg-fp-left');
        DOM.removeClass(toggleLeftBgElem, 'cgp-themes-icons-gameframe-bg-real-left');
        DOM.removeClass(toggleLeftBgElem, 'cgp-themes-icons-gameframe-bg-demo-left');

        DOM.removeClass(toggleRightBgElem, 'cgp-themes-icons-gameframe-bg-fp-right');
        DOM.removeClass(toggleRightBgElem, 'cgp-themes-icons-gameframe-bg-real-right');
        DOM.removeClass(toggleRightBgElem, 'cgp-themes-icons-gameframe-bg-demo-right');
    }
}